import {defaultLocale,  localePrefix, locales, pathnames} from "@/config/i18n";
import { configureRouting } from "@itchannelplus/utils";

export const {
  routing,
  Link:I18nLink,
  redirect,
  usePathname,
  useRouter,
  getPathname,
  permanentRedirect,
  withLocale,
  notFoundForUnknownLocale,
  languageDetector
} = configureRouting({
  // A list of all locales that are supported
  locales: locales,
  // Used when no locale matches
  defaultLocale: defaultLocale,
  localePrefix: localePrefix,
  pathnames: pathnames
})

export type Pathnames = keyof typeof routing.pathnames;
export type Locale = (typeof routing.locales)[number];
